import React, { useRef, useState } from "react";
import CustomSelect from "../globalcontrols/customselect/customselect";

// Keep native form validation and the existing select change contract, while
// presenting OVM's shared custom menu and animated iOS arrow.
export default function CostSelect({ children, value, onChange, label, required, disabled, ...props }) {
  const wrapper = useRef(null);
  const [invalid, setInvalid] = useState(false);
  const change = event => { setInvalid(false); onChange?.(event); };
  const options = React.Children.toArray(children).filter(React.isValidElement).map(option => ({
    value: String(option.props.value ?? ""),
    label: React.Children.toArray(option.props.children).join(""),
    disabled: Boolean(option.props.disabled),
  }));
  return <div className="cc-custom-select" ref={wrapper}>
    <select {...props} aria-label={label || props["aria-label"]} className="cc-select-validation" tabIndex={-1}
      value={value ?? ""} onChange={change} required={required} disabled={disabled}
      onInvalid={event => { event.preventDefault(); setInvalid(true); wrapper.current?.querySelector(".custom-select-trigger")?.focus(); }}>
      {children}
    </select>
    <CustomSelect label={`Abrir ${label || props["aria-label"] || "selección"}`} options={options} selectedValue={String(value ?? "")}
      labelExtractor={option => option.label} valueExtractor={option => option.value} disabledExtractor={option => option.disabled}
      onChange={selected => change({ target: { value: selected } })} disabled={disabled} iosArrow searchable={options.length > 8} />
    {invalid && <small role="alert">Selecciona una opción para continuar.</small>}
  </div>;
}
